import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

import { getSynopDesktop } from './bridge'

export type DesktopTelemetryContext = {
  version: string
  platform: string
  installId?: string
}

/**
 * Stamps RUM sessions and browser logs with the desktop shell they run in,
 * so desktop users are a filter in Datadog rather than a user-agent regex,
 * and a session that stops dead can be matched with the shell's own
 * `synop-desktop` log entry carrying the same installId. A no-op in a
 * browser.
 */
export async function tagDesktopTelemetry(): Promise<DesktopTelemetryContext | undefined> {
  const bridge = getSynopDesktop()
  if (!bridge) return undefined
  try {
    const { version, platform, installId } = await bridge.getContext()
    const desktop: DesktopTelemetryContext = { version, platform, installId }
    datadogRum.setGlobalContextProperty('desktop', desktop)
    datadogLogs.setGlobalContextProperty('desktop', desktop)
    return desktop
  } catch {
    return undefined
  }
}
